import { getCurrentUser } from '../auth';
import { postUserFeedback } from '../api';
import suppressGlobalErrors from './suppressGlobalErrors';

export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_PENDING = 'GET_CURRENT_USER_PENDING';
export const GET_CURRENT_USER_FULFILLED = 'GET_CURRENT_USER_FULFILLED';
export const SUBMIT_USER_FEEDBACK = 'SUBMIT_USER_FEEDBACK';

export const getCurrentUserAction = () => suppressGlobalErrors({
  type: GET_CURRENT_USER,
  payload: getCurrentUser()
});

export const submitUserFeedback = (message) => ({
  type: SUBMIT_USER_FEEDBACK,
  payload: postUserFeedback(message)
});
